'use strict';
define('polyfills',['es6-promise-polyfill'], function(promise) {

    //This is pollyfill for old IE trim method
    if (typeof String.prototype.trim !== 'function') {
        String.prototype.trim = function() {
            return this.replace(/^\s+|\s+$/g, '');
        };
    }

    /**
     * DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE
     * Version 2, December 2004
     *
     * Copyright (C) 2011 Alex Kloss <alexthkloss@web.de>
     *
     * Everyone is permitted to copy and distribute verbatim or modified
     * copies of this license document, and changing it is allowed as long
     * as the name is changed.
     *
     * DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE
     * TERMS AND CONDITIONS FOR COPYING, DISTRIBUTION AND MODIFICATION
     *
     * 0. You just DO WHAT THE FUCK YOU WANT TO.
     */
    [].indexOf || (Array.prototype.indexOf = function(a, b, c) {
        for (c = this.length, b = (c + ~~b) % c; b < c && (!(b in this) || this[b] !== a); ++b) {
            //do nothing
        } return b ^ c ? b : -1;
    });

    [].forEach || (Array.prototype.forEach = function(a, b, c, d) {
        for (d = this.length, c = 0; c < d; ++c) {
            c in this && a.call(b, this[c], c, this)
        }
    });

    if (window.Promise === undefined) {
        window.Promise = promise;
    }
});

